export enum Feature {
  BUYSPACES_MODULE = "BUYSPACES_MODULE",
  CUSTOM_FIELDS_MODULE = "CUSTOM_FIELDS_MODULE",
  GOAL_MODULE = "GOAL_MODULE",
  SUPPLIER_QUESTIONNAIRES = "SUPPLIER_QUESTIONNAIRES"
}
